import React from "react";
import { useFormStore } from "src/store/dataEntryForm";
import moment from "moment";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { DatePicker } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { Input } from "@components/ui-kit/Input";

interface FormFieldProps {
  formId: string;
  fieldName: string;
  label: string;
  placeholder?: string;
  type?: "text" | "number" | "date" | "time";
  inputType?: "text" | "number";
  size?: "small" | "large" | "extrasmall";
  icon?: React.ReactNode;
}

export const FormField: React.FC<FormFieldProps> = ({
  formId,
  fieldName,
  label,
  placeholder = "",
  type = "text",
  inputType = "text",
  size = "large",
  icon,
}) => {
  const { formData, updateFormField } = useFormStore();
  const value = formData[formId]?.[fieldName] || "";

  const handleChange = (newValue: string) => {
    if (type === "number" && newValue.length === 6 && newValue[3] !== ",") {
      const temp = newValue.split("");
      temp.splice(3, 0, ",");
      newValue = temp.join("");
    }
    updateFormField(formId, fieldName, newValue);
  };

  if (type === "date") {
    const momentValue = value ? moment(value) : null;

    return (
      <div
        className={styles.formField}
        style={{ width: size === "large" ? "100%" : "calc(50%)" }}
      >
        <label className={styles.fieldLabel}>{label}</label>
        <div className={styles.datePickerWrapper}>
          <span className={styles.customCalendarIcon}>
            {icon || <CalendarOutlined />}
          </span>
          <DatePicker
            placeholder={placeholder}
            value={momentValue}
            onChange={(_, dateString) => {
              handleChange(dateString);
            }}
            format="YYYY-MM-DD"
            className={classNames(styles.datePicker, "form-field-date")}
            suffixIcon={null}
          />
        </div>
      </div>
    );
  }

  return (
    <Input
      label={label}
      placeholder={placeholder}
      value={value.toString()}
      onChange={handleChange}
      className={styles.formField}
      type={inputType}
      style={{ width: size === "large" ? "100%" : "50%" }}
      icon={icon}
    />
  );
};
